//全サイト共通のグローバル変数（兼dev環境用設定共通ファイル）
const base = {
  // ENV
  ENV: "development",
  // APP ID
  APP_ID: "youngchampion",

  // キャッシュ制御
  DEFAULT_CACHE_TIME: 300,
  LONG_CACHE_TIME: 3600,

  //レスポンシブブレイクポイント
  BREAKPOINT_SP: 768,

  //待つと無料のリカバリー時間（秒）
  WAIT_AND_FREE_RECOVERY: 10 * 60, //10分

  // 本棚各ページの1ページあたり表示アイテム数
  BOOKSHELF_ITEM_COUNT: 12,

  // 検索結果の1ページあたり表示アイテム数
  SEARCH_ITEM_COUNT: 24,

  // URL
  // ""になってるところは.envもしくは各サイトの設定ファイルで設定
  HOME_URL: process.env.NEXT_PUBLIC_HOME_URL,
  AUTH_ENDPOINT: process.env.NEXT_PUBLIC_COMICI_AUTH_API_ENDPOINT,
  API_ENDPOINT: process.env.NEXT_PUBLIC_API_ENDPOINT,

  DASHBOARD_DOMAIN: "",
  DASHBOARD_DOMAIN_PREFIX: "",

  //viewer
  VIEWER_API_DOMAIN: "youngchampion.jp",
  VIEWER_API_DOMAIN_PREFIX: "",
  VIEWER_AD_ID: "div-gpt-ad-1712716823432-0",
  VIEWER_USE_COMMON_DEV_DOMAIN: true,
  VIEWER_API_COMMON_DEV_DOMAIN_SUFFIX: "",

  FAN_LETTER_URL:
    "https://docs.google.com/forms/d/e/1FAIpQLScqWdBQbT9Zx3I4LT__16dDob5ODtaK8fn6tq_xP5TnuLCl1Q/viewform?usp=pp_url&entry.571026602=",

  // ミッションの「シェアボタンの場所を確認する」のURL
  SHARE_BUTTON_HELP_URL: "https://support.comici.jp/hc/ja/articles/11468395959439",

  // content_id
  CONTENT_ID: 7,

  // logging
  // ログの送信先ドメイン（viewerでも使うため、https://は含めない形で指定）
  LOG_ENDPOINT_DOMAIN: "api-ai.dev.comici.jp",
  LOG_TRACKING_ID: "8TK4ofCuZLdEJAyHtbm3FhX4toAqNzAg",
  LOG_SITE_NAME: "localhost",
  LOG_DOMAIN: "magazine.comici.jp",

  // google tag manager
  GTM_ID_PROD_GLOBAL: "GTM-KH8JDCV",
  GTM_ID_DEV_GLOBAL: "GTM-WWLV69N",
  GTM_ID_PROD: "GTM-KH8JDCV",
  GTM_ID_DEV: "GTM-WWLV69N",

  // Stripe
  STRIPE_API_VERSION: "2025-05-28.basil" as const,

  // SHARE
  SHARE_HASHTAG: "#コミチマガジン",
  SHARE_USER: "@comici_jp",

  // coin/point/rental
  IS_RENTAL: true,
  RENTAL_PERIOD: "15日間",

  // mission
  // ミッションのプロモーションID (コンテンツミッションプロモーションテーブルのレコードID)
  SHARE_MISSION_PROMOTION_ID: 3,

  // お問い合わせ
  HELP_URL: "https://support.comici.jp/hc/ja",
  HELP_PATH_COIN: "/categories/5500146021775-コインついて",
  // カード登録/編集ページの対応ブランドヘルプリンク先URL
  HELP_PATH_SUPPORTED_CARD_BRAND: "/articles/5681703039247-支払い手段-決済方法-について",
  // カード登録/編集ページのカード情報の取り扱いヘルプリンク先URL
  HELP_PATH_CARD_INFO: "/articles/5681749154447-カード情報の取り扱いの安全性について教えてください",

  // copyright
  FOOTER_COPYRIGHT: "©2022 comici, Inc.",
  // footer urls
  FOOTER_COMPANY_URL: "https://comici.co.jp",
  FOOTER_TERMS_URL: "https://comici.co.jp/terms",
  FOOTER_PRIVACY_URL: "https://comici.co.jp/privacy",
  FOOTER_TOKUSHOHOU_URL: "https://comici.co.jp/tokushohou",

  // ============== PAGE SETTINGS ===================

  //初めての方へページがあるかどうか
  HAS_TUTORIAL_PAGE: true,

  //グラビアページがあるかどうか
  HAS_GRAVURE: false,

  //記事ページがあるかどうか
  HAS_COLUMN: false,

  //著者ページがあるかどうか
  HAS_AUTHOR_PAGE: false,
  // 作家一覧ページがあるかどうか
  HAS_AUTHOR_LIST: false,

  //マンガトップに曜日選択を表示するかどうか
  HAS_MANGA_WEEK_NAV: false,
  //グラビアトップに曜日選択を表示するかどうか
  HAS_GRAVURE_WEEK_NAV: false,
  //グラビアトップのタブは「連載」「全て」どちらか
  IS_GRAVURE_TAB_ALL: false,

  //記事トップに曜日選択を表示するかどうか
  HAS_COLUMN_WEEK_NAV: false,

  //ガチャページがあるかどうか
  HAS_GACHA_PAGE: false,
  //ミッション機能あるかどうか
  HAS_MISSION: false,

  HAS_HEADER_DECORATION: false,

  // ======== 特殊仕様 ==========

  //コミチID連携サイトかどうか
  USING_COMICI_ID: true,

  //小トップを使う
  USING_SUB_TOP: false,

  // ↓の３つはtype.d.ts内で定義されてます
  //HOME_SUB_TOP_NAV: undefined,
  //FOOTER_SUB_TOP_NAV: undefined,
  //FOOTER_EXTERNAL_LINKS_NAV: undefined,

  //集英社ID使用サイト
  USING_SHUEISHA_ID: false,
};

export default base;
